import axiosClient from '@/api/axiosClient'
import type {
  BootstrapProjectResponse,
  BootstrapUserResponse
} from '@/types/bootstrap'

/**
 * Henter konsolidert first-paint-state for innlogget bruker.
 * Erstatter post-login fan-out (/user/global-admin/check + /user/databases + /project).
 * Krever Bearer-token; ingen Ics-Project-Id-header (project-independent endpoint).
 */
export async function getBootstrapUser (signal?: AbortSignal): Promise<BootstrapUserResponse> {
  const response = await axiosClient.get<BootstrapUserResponse>('/bootstrap/user', { signal })
  return response.data
}

/**
 * Henter konsolidert first-paint-state for ett prosjekt. Slug-basert oppslag —
 * ingen Ics-Project-Id-header (project-independent endpoint).
 *
 * @param slug projectSlug (URL-vennlig prosjekt-id)
 * @param publicId valgfri ressurs-id (publicId for table/view/report)
 * @param publicIdType valgfri ressurs-type ("table", "dataView", "report")
 * @param signal AbortSignal for å kansellere requesten
 *
 * 404 (project-not-found), 403 (no-role | project-archived | no-item-access) returneres
 * som axios-feil; konsumenter må sjekke `error.response.status` + `error.response.data.reason`.
 */
export async function getBootstrapProject (
  slug: string,
  publicId?: string,
  publicIdType?: string,
  signal?: AbortSignal
): Promise<BootstrapProjectResponse> {
  const params = new URLSearchParams()
  if (publicId) params.set('publicId', publicId)
  if (publicIdType) params.set('publicIdType', publicIdType)
  const query = params.toString()
  const url = query.length > 0
    ? `/bootstrap/project/${encodeURIComponent(slug)}?${query}`
    : `/bootstrap/project/${encodeURIComponent(slug)}`
  const response = await axiosClient.get<BootstrapProjectResponse>(url, { signal })
  return response.data
}
